export function createAttribute(name: string) {
  return `data-base-ui-${name}`;
}
